export default __webpack_public_path__ + "static/media/ferramenta-reels-img4.09822a98.jpeg";